<!-- 基本信息 -->
<template>
  <div class="container">
    <div class="vue">
      <div class="header   flex flexColumn">
        <div class="head-title borderB">
          <div class="text">受监护人员</div>
        </div>
        <div class="headSearch">
          <div class="headSearch-left Fs14" style="width: 100%;">
            <div class="form-data group">
              <span>用户名：</span>
              <el-input v-model="SearchForm.name" style="width: 150px;" size="mini"placeholder="" clearable></el-input>
            </div>
            <div class="form-data group">
              <span>手机号：</span>
              <el-input v-model="SearchForm.tel" style="width: 150px;" size="mini" placeholder="" clearable></el-input>
            </div>
            <div class="form-data group">
              <span>所属地区：</span>
              <el-input v-model="SearchForm.community" size="mini" placeholder="" clearable></el-input>
            </div>
            <div class="form-data group">
              <span>服务项目：</span>
              <el-input v-model="SearchForm.serviceItem" size="mini" placeholder="" clearable></el-input>
            </div>
            <div class="form-data group">
              <el-button @click="SearchBut" round type="primary" size="mini">搜索</el-button>
              <el-button @click="personAddBut" icon="el-icon-plus" round type="primary" size="mini">新增人员</el-button>
            </div>
          </div>
        </div>
      </div>
      <div class="content">
        <el-table
          :header-cell-style="{ background: '#f5f5f5' }"
          :data="PersonList.list"
          style="width: 100%">
          <el-table-column prop="id" label="#" min-width="1"> </el-table-column>
          <el-table-column prop="name" label="用户名" min-width="1"> </el-table-column>
          <el-table-column prop="tel" label="手机号" min-width="2"> </el-table-column>
          <el-table-column prop="sex" label="性别" min-width="1">
            <template slot-scope="scope">
              <span>{{ scope.row.sex | filterSex }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="age" label="年龄" min-width="1">
            <template slot-scope="scope">
              <span>{{ scope.row.birth | calculateAge }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="birth" label="出生日期" min-width="2">
            <template slot-scope="scope">
              <span>{{ scope.row.birth | filterTime(1) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="community" label="所属地区" min-width="1"></el-table-column>
          <el-table-column prop="state" label="服务状态" min-width="1"></el-table-column>
          <!--<el-table-column prop="idcard" label="身份证号" min-width="2"></el-table-column>-->
          <el-table-column prop="serviceItem" label="服务项目" min-width="2"></el-table-column>
          <el-table-column prop="createTime" label="最近上传" min-width="2">
            <template slot-scope="scope">
                <span :style="{'color': scope.row.isToday ? 'red': 'black'}">{{ scope.row.createTime | filterTime }}</span>
              </template>
          </el-table-column>
          <el-table-column label="操作" min-width="3">
            <template slot-scope="scope">
              <el-button @click="personUpdateBut(scope.row)" type="primary" size="small">详情</el-button>
              <el-button @click="personLogBut(scope.row)" type="primary" size="small">检测记录</el-button>
              <!-- <el-button @click="personDeviceBut(scope.row)" type="primary" size="small">设备</el-button>
              <el-button @click="personDeleteClick(scope.row)" type="danger" size="small">删除</el-button> -->
              <el-dropdown style="margin-left: 10px;">
                <el-button type="danger" size="small">
                  更多<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="personDeviceBut(scope.row)">设备</el-dropdown-item>
                  <el-dropdown-item @click.native="personDeleteClick(scope.row)">删除</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
        <div class="Pagination flex">
          <div class="text">
            <span>共{{ PersonList.total }}条记录，</span>
            <span class="pageNum">{{ PersonList.pageNum }}</span>
            <span>/{{ PersonList.pages }}页</span>
          </div>
          <el-pagination
            v-if="PersonList !== ''"
            @current-change="handleCurrentChange"
            :current-page.sync="PersonList.pageNum"
            :page-size="PersonList.pageSize"
            layout="prev, pager, next, jumper"
            :total="PersonList.total">
          </el-pagination>
        </div>
      </div>
    </div>

    <!-- 动态信息 -->
    <el-dialog title="动态信息" width="1000px" :visible.sync="personDialogVisible" :append-to-body="true">
      <div>
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="人员信息" name="first" id="first">
            <el-form ref="personForm" :model="personForm" :rules="rules" label-width="120px">
              <el-row type="flex" justify="space-between" align="middle">
                <el-col :span="12">
                  <el-form-item label="绑定账号">
                    <el-select v-model="personForm.uid" filterable placeholder="请选择" @change="bindPersonChange">
                      <el-option v-for="item in UsersList" :key="item.id" :label="item.tel" :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="所属地区" prop="community">
                    <el-select v-model="personForm.community" filterable placeholder="请选择">
                      <el-option v-for="item in communityOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row type="flex" justify="space-between" align="middle">
                <el-col :span="12">
                  <el-form-item label="姓名" prop="name">
                    <el-input v-model="personForm.name"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="性别" prop="sex">
                    <el-select v-model="personForm.sex" filterable placeholder="请选择">
                      <el-option v-for="item in sexOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row type="flex" justify="space-between" align="middle">
                <el-col :span="12">
                  <el-form-item label="联系电话" prop="tel">
                    <el-input v-model="personForm.tel"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="服务项目" prop="serviceItemArr">
                    <el-select v-model="personForm.serviceItemArr" filterable placeholder="请选择" multiple @change="$forceUpdate()">
                      <el-option v-for="item in siOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row type="flex" justify="space-between" align="middle">
                <el-col :span="12">
                  <el-form-item label="出生日期" prop="birth">
                    <el-date-picker v-model="personForm.birth" type="date" placeholder="选择日期"></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="身份证号" prop="idcard">
                    <el-input v-model="personForm.idcard"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row type="flex" justify="space-between" align="middle">
                <el-col :span="24">
                  <el-form-item label="居住地址" prop="address">
                    <el-input v-model="personForm.address"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row type="flex" justify="space-between" align="middle">
                <el-col :span="12">
                  <el-form-item label="监护名字">
                    <el-input v-model="personForm.hgName"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="联系电话">
                    <el-input v-model="personForm.hgTel"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row type="flex" justify="space-between" align="middle">
                <el-col :span="12">
                  <el-form-item label="家属名字">
                    <el-input v-model="personForm.jsName"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="联系电话">
                    <el-input v-model="personForm.jsTel"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row type="flex" justify="space-between" align="middle">
                <el-col :span="12">
                  <el-form-item label="紧急电话">
                    <el-input v-model="personForm.jjTel"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="服务状态" prop="state">
                    <el-select v-model="personForm.state" filterable placeholder="请选择">
                      <el-option v-for="item in stateOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="体检报告" name="second" id="second">
            <el-table
              :header-cell-style="{ background: '#f5f5f5' }"
              :data="ReportList.list"
              style="width: 100%">
              <el-table-column prop="id" label="#" min-width="1"></el-table-column>
              <el-table-column prop="reportName" label="报告名" min-width="2"> </el-table-column>
              <el-table-column prop="reportNum" label="报告编号" min-width="2"> </el-table-column>
              <el-table-column prop="institution" label="检测机构" min-width="3"> </el-table-column>
              <el-table-column prop="tester" label="检测医生" min-width="2"> </el-table-column>
              <el-table-column prop="doTime" label="检测时间" min-width="2">
                <template slot-scope="scope">
                  <span>{{ scope.row.doTime | filterTime(1) }}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" min-width="1">
                <template slot-scope="scope">
                  <el-button @click="reportClick(scope.row)" type="primary" size="small">详情</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="Pagination flex">
              <div class="text">
                <span>共{{ ReportList.total }}条记录，</span>
                <span class="pageNum">{{ ReportList.pageNum }}</span>
                <span>/{{ ReportList.pages }}页</span>
              </div>
              <el-pagination
                v-if="ReportList !== ''"
                @current-change="handleReportCurrentChange"
                :current-page.sync="ReportList.pageNum"
                :page-size="ReportList.pageSize"
                layout="prev, pager, next, jumper"
                :total="ReportList.total">
              </el-pagination>
            </div>
          </el-tab-pane>
          <el-tab-pane label="健管方案" name="third" id="third">
            <el-table
              :header-cell-style="{ background: '#f5f5f5' }"
              :data="SchemeList.list"
              style="width: 100%">
              <el-table-column prop="id" label="#" min-width="1"></el-table-column>
              <el-table-column prop="schemeType" label="方案类型" min-width="2" >
                <template slot-scope="scope">
                  <span>{{ scope.row.schemeType | filterSchemeType }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="schemeName" label="方案名" min-width="2"> </el-table-column>
              <el-table-column prop="institution" label="方案机构" min-width="3"> </el-table-column>
              <el-table-column prop="doTime" label="方案时间" min-width="2">
                <template slot-scope="scope">
                  <span>{{ scope.row.doTime | filterTime(1) }}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" min-width="1">
                <template slot-scope="scope">
                  <el-button @click="schemeClick(scope.row)" type="primary" size="small">详情</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="Pagination flex">
              <div class="text">
                <span>共{{ SchemeList.total }}条记录，</span>
                <span class="pageNum">{{ SchemeList.pageNum }}</span>
                <span>/{{ SchemeList.pages }}页</span>
              </div>
              <el-pagination
                v-if="SchemeList !== ''"
                @current-change="handleSchemeCurrentChange"
                :current-page.sync="SchemeList.pageNum"
                :page-size="SchemeList.pageSize"
                layout="prev, pager, next, jumper"
                :total="SchemeList.total">
              </el-pagination>
            </div>
          </el-tab-pane>
          <el-tab-pane label="异常报警" name="fourth" id="fourth">
            <el-table
              :header-cell-style="{ background: '#f5f5f5' }"
              :data="MsgList.list"
              style="width: 100%">
              <el-table-column prop="id" label="#" min-width="1"> </el-table-column>
              <el-table-column prop="xm" label="监护项目" min-width="4">
                <template slot-scope="scope">
                  <span>{{ scope.row.xm | filterXm }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="createTime" label="报警时间" min-width="3">
                <template slot-scope="scope">
                  <span>{{ scope.row.createTime | filterTime }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="status" label="处理状态" min-width="3">
                <template slot-scope="scope">
                  <span>{{ scope.row.status | filterAlertStatus }}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" min-width="2">
                <template slot-scope="scope">
                  <el-button @click="msgClick(scope.row)" type="primary" size="small">详情</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="Pagination flex">
              <div class="text">
                <span>共{{ MsgList.total }}条记录，</span>
                <span class="pageNum">{{ MsgList.pageNum }}</span>
                <span>/{{ MsgList.pages }}页</span>
              </div>
              <el-pagination
                v-if="MsgList !== ''"
                @current-change="handleMsgCurrentChange"
                :current-page.sync="MsgList.pageNum"
                :page-size="MsgList.pageSize"
                layout="prev, pager, next, jumper"
                :total="MsgList.total">
              </el-pagination>
            </div>
          </el-tab-pane>
          <el-tab-pane label="今日管理" name="fifth" id="fifth">
            <el-table :header-cell-style="{ background: '#f5f5f5' }" :data="TodayList.list" style="width: 100%">
              <el-table-column prop="id" label="#" min-width="1"> </el-table-column>
              <el-table-column prop="createTime" label="上传日期" min-width="3">
                <template slot-scope="scope">
                  <span :style="{'color': scope.row.isToday ? 'red': 'black'}">{{ scope.row.createTime | filterTime(1) }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="hasReply" label="是否已回复" min-width="3">
                <template slot-scope="scope">
                  <span>{{ scope.row.hasReply | filterHasVisit }}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" min-width="1">
                <template slot-scope="scope">
                  <el-button @click="todayClick(scope.row)" type="primary" size="small">详情</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="Pagination flex">
              <div class="text">
                <span>共{{ TodayList.total }}条记录，</span>
                <span class="pageNum">{{ TodayList.pageNum }}</span>
                <span>/{{ TodayList.pages }}页</span>
              </div>
              <el-pagination
                v-if="TodayList !== ''"
                @current-change="handleTodayCurrentChange"
                :current-page.sync="TodayList.pageNum"
                :page-size="TodayList.pageSize"
                layout="prev, pager, next, jumper"
                :total="TodayList.total">
              </el-pagination>
            </div>
          </el-tab-pane>
          <el-tab-pane label="疗愈生活" name="sixth" id="sixth">
            <el-table :header-cell-style="{ background: '#f5f5f5' }" :data="HealingList.list" style="width: 100%">
              <el-table-column prop="id" label="#" min-width="1"></el-table-column>
              <el-table-column prop="reportName" label="记录名" min-width="2"> </el-table-column>
              <el-table-column prop="reportNum" label="记录编号" min-width="2"> </el-table-column>
              <el-table-column prop="tester" label="指导医生" min-width="2"> </el-table-column>
              <el-table-column prop="createTime" label="创建时间" min-width="2">
                <template slot-scope="scope">
                  <span>{{ scope.row.createTime | filterTime(1) }}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" min-width="1">
                <template slot-scope="scope">
                  <el-button @click="healingClick(scope.row)" type="primary" size="small">详情</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="Pagination flex">
              <div class="text">
                <span>共{{ HealingList.total }}条记录，</span>
                <span class="pageNum">{{ HealingList.pageNum }}</span>
                <span>/{{ HealingList.pages }}页</span>
              </div>
              <el-pagination
                v-if="HealingList !== ''"
                @current-change="handleHealingCurrentChange"
                :current-page.sync="HealingList.pageNum"
                :page-size="HealingList.pageSize"
                layout="prev, pager, next, jumper"
                :total="HealingList.total">
              </el-pagination>
            </div>
          </el-tab-pane>
          <el-tab-pane label="随访管理" name="seventh" id="seventh">
            <el-table :header-cell-style="{ background: '#f5f5f5' }" :data="AccessList.list" style="width: 100%">
              <el-table-column prop="id" label="#" min-width="1"> </el-table-column>
              <el-table-column prop="planTime" label="计划随访时间" min-width="2">
                <template slot-scope="scope">
                  <span>{{ scope.row.planTime | filterTime(1) }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="hasVisit" label="是否登记" min-width="2">
                <template slot-scope="scope">
                  <span>{{ scope.row.hasVisit | filterHasVisit }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="visitTime" label="正式随访时间" min-width="2">
                <template slot-scope="scope">
                  <span>{{ scope.row.visitTime | filterTime(1) }}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" min-width="1">
                <template slot-scope="scope">
                  <el-button @click="accessClick(scope.row)" type="primary" size="small">详情</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="Pagination flex">
              <div class="text">
                <span>共{{ AccessList.total }}条记录，</span>
                <span class="pageNum">{{ AccessList.pageNum }}</span>
                <span>/{{ AccessList.pages }}页</span>
              </div>
              <el-pagination
                v-if="AccessList !== ''"
                @current-change="handleAccessCurrentChange"
                :current-page.sync="AccessList.pageNum"
                :page-size="AccessList.pageSize"
                layout="prev, pager, next, jumper"
                :total="AccessList.total">
              </el-pagination>
            </div>
          </el-tab-pane>
          <!--
          <el-tab-pane label="服务订单" name="fifth">
            <el-table :header-cell-style="{ background: '#f5f5f5' }" :data="OrderList.list" style="width: 100%">
              <el-table-column prop="id" label="#" min-width="1"> </el-table-column>
              <el-table-column label="订单时间" min-width="2">
                <template slot-scope="scope">
                  <span>{{ scope.row.dingdanshijian | filterTime }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="indentname" label="商品名" min-width="2"></el-table-column>
              <el-table-column label="订单状态" min-width="2">
                <template slot-scope="scope">
                  <span>{{ scope.row.payType | filterPayType }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="outTradeNo" label="订单号" min-width="2"></el-table-column>
              <el-table-column prop="payTypes" label="支付方式" min-width="1"></el-table-column>
              <el-table-column prop="indentprice" label="金额" min-width="1"> </el-table-column>
              <el-table-column prop="server" label="服务人员" min-width="1"></el-table-column>
            </el-table>
            <div class="Pagination flex">
              <div class="text">
                <span>共{{ OrderList.total }}条记录，</span>
                <span class="pageNum">{{ OrderList.pageNum }}</span>
                <span>/{{ OrderList.pages }}页</span>
              </div>
              <el-pagination
                v-if="MsgList !== ''"
                @current-change="handleOrderCurrentChange"
                :current-page.sync="OrderList.pageNum"
                :page-size="OrderList.pageSize"
                layout="prev, pager, next, jumper"
                :total="OrderList.total">
              </el-pagination>
            </div>
          </el-tab-pane>
          -->
        </el-tabs>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="personDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="personUpdateClick">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 监护设备列表 -->
    <el-drawer
      title="设备列表"
      :size="drawerWidth"
      :visible.sync="drawer"
      :append-to-body="true"
      :before-close="handleClose">
      <div class="scroll-container">
        <div style="margin: 10px;">
          <el-button @click="personDeviceAddBut" round type="primary" size="mini" style="float: right; margin-bottom: 5px;margin-right: 5px;">新增设备</el-button>
          <el-table :data="personDeviceList" border style="width: 100%"
            :header-cell-style="{ background: '#f5f7fa !important' ,color:'#909399 !important'}">
            <el-table-column prop="deviceCode" label="设备码" min-width="3"></el-table-column>
            <el-table-column prop="deviceName" label="设备名" min-width="3"></el-table-column>
            <el-table-column prop="type" label="类型" min-width="2">
              <template slot-scope="scope">
                <span>{{ scope.row.type | filterXm }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="normalRange" label="数值范围" min-width="4"></el-table-column>
            <el-table-column prop="status" label="状态" min-width="1">
              <template slot-scope="scope">
                <span>{{ scope.row.status | filterStatus }}</span>
              </template>
            </el-table-column>
            <el-table-column min-width="2" label="操作">
              <template slot-scope="scope">
                <el-button size="mini" type="primary" icon="el-icon-document" @click="personDeviceUpdateBut(scope.$index, scope.row)"></el-button>
                <el-button size="mini" type="danger" icon="el-icon-delete" @click="personDeviceDeleteClick(scope.$index, scope.row)"></el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </el-drawer>

    <!-- 新增设备 -->
    <el-dialog title="设备信息" width="500px" :visible.sync="personDeviceDialogVisible" :append-to-body="true">
      <div>
        <el-form ref="personDeviceForm" :model="personDeviceForm" :rules="deviceRules" label-width="100px">
          <el-form-item label="设备类型" prop="type">
            <el-select v-model="personDeviceForm.type" placeholder="请选择" style="width: 100%;" @change="deviceTypeChange">
              <el-option v-for="item in typeOptions"
                :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="未绑定设备" prop="deviceCodeSelect">
            <el-select v-model="personDeviceForm.deviceCodeSelect" placeholder="请选择" style="width: 100%;" @change="bindDeviceChange">
              <el-option v-for="item in deviceOptions"
                :key="item.deviceCode" :label="item.deviceCode" :value="item.deviceCode">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="设备码" prop="deviceCode">
            <el-input v-model="personDeviceForm.deviceCode"></el-input>
          </el-form-item>
          <el-form-item label="设备名" prop="deviceName">
            <el-input v-model="personDeviceForm.deviceName"></el-input>
          </el-form-item>
          <el-form-item label="数值范围" prop="normalRange">
            <el-input v-model="personDeviceForm.normalRange"></el-input>
          </el-form-item>
          <el-form-item label="状态" prop="status">
            <el-select v-model="personDeviceForm.status" placeholder="请选择" style="width: 100%;">
              <el-option v-for="item in statusOptions"
                :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="personDeviceDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="personDeviceUpdateClick">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 报告 -->
    <el-dialog title="报告信息" width="800px" :visible.sync="reportDialogVisible" :append-to-body="true" custom-class="outer-dialog">
      <el-form ref="reportForm" :model="reportForm" label-width="100px">
        <el-card class="box-card">
          <el-row>
            <el-col :span="12">
              <el-form-item label="报告名称" prop="reportName">
                <span>{{ reportForm.reportName }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="报告编号" prop="reportNum">
                <span>{{ reportForm.reportNum }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="检测机构" prop="institution">
                <span>{{ reportForm.institution }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="检测时间" prop="doTime">
                <span>{{ reportForm.doTime | filterTime(1) }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="检测医生" prop="tester">
                <span>{{ reportForm.tester }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="备注" prop="note">
                <span>{{ reportForm.note }}</span>
              </el-form-item>
            </el-col>
          </el-row>
        </el-card>
        <el-card class="box-card" style="margin-top: 10px;">
          <div slot="header" class="clearfix">
            <el-tag type="danger" effect="plain">报告附件</el-tag>
            <el-table :data="reportImgList" border style="width: 100%; margin-top: 20px;"
              :header-cell-style="{ background: '#f5f7fa !important' ,color:'#909399 !important'}">
              <el-table-column prop="imgName" label="文件名称" min-width="2"></el-table-column>
              <el-table-column prop="imgUrl" label="点击预览" min-width="1">
                <template slot-scope="scope">
                  <div v-if="scope.row.imgUrl.endsWith('.pdf')">
                    <a :href="scope.row.imgUrl" target="_blank" style="font-weight: 800; color: #33ab9e">点击预览</a>
                  </div>
                  <div class="demo-image__preview" v-else>
                    <el-image style="width: 100px; height: 100px" :src="scope.row.imgUrl" :preview-src-list="srcList"></el-image>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-card>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="reportDialogVisible = false">关 闭</el-button>
      </div>
    </el-dialog>

    <!-- 健管方案 -->
    <el-dialog title="健管方案" width="800px" :visible.sync="schemeDialogVisible" :append-to-body="true" custom-class="outer-dialog">
      <el-form ref="schemeForm" :model="schemeForm" label-width="100px">
        <el-card class="box-card">
          <el-row>
            <el-col :span="12">
              <el-form-item label="方案类型" prop="schemeType">
                <span>{{ schemeForm.schemeType | filterSchemeType }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="方案名称" prop="schemeName">
                <span>{{ schemeForm.schemeName }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="方案机构" prop="institution">
                <span>{{ schemeForm.institution }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="方案时间" prop="doTime">
                <span>{{ schemeForm.doTime | filterTime(1) }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="备注" prop="note">
                <span>{{ schemeForm.note }}</span>
              </el-form-item>
            </el-col>
          </el-row>
        </el-card>
        <el-card class="box-card" style="margin-top: 10px;">
          <div slot="header" class="clearfix">
            <el-tag type="danger" effect="plain">方案附件</el-tag>
            <el-table :data="schemeImgList" border style="width: 100%; margin-top: 20px;"
              :header-cell-style="{ background: '#f5f7fa !important' ,color:'#909399 !important'}">
              <el-table-column prop="imgName" label="文件名称" min-width="2"></el-table-column>
              <el-table-column prop="imgUrl" label="点击预览" min-width="1">
                <template slot-scope="scope">
                  <div v-if="scope.row.imgUrl.endsWith('.pdf')">
                    <a :href="scope.row.imgUrl" target="_blank" style="font-weight: 800; color: #33ab9e">点击预览</a>
                  </div>
                  <div class="demo-image__preview" v-else>
                    <el-image style="width: 100px; height: 100px" :src="scope.row.imgUrl" :preview-src-list="srcSchemeList"></el-image>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-card>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="schemeDialogVisible = false">关 闭</el-button>
      </div>
    </el-dialog>

    <!-- 处理进度 -->
    <el-dialog title="报警信息" width="800px" :visible.sync="msgDialogVisible" :append-to-body="true">
        <div>
          <el-form ref="msgForm" :model="msgForm" :rules="rules" label-width="80px">
            <el-row type="flex" justify="space-between" align="middle">
              <el-col :span="24">
                <el-form-item label="报警设备" prop="xm">
                  {{ msgForm.xm | filterXm }}
                </el-form-item>
              </el-col>
            </el-row>
            <el-row type="flex" justify="space-between" align="middle">
              <el-col :span="24">
                <el-form-item label="报警内容" prop="content">
                  <el-input v-model="msgForm.content" :readonly="true" type="textarea" :rows="4" placeholder=""></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row type="flex" justify="space-between" align="middle">
              <el-col :span="24">
                <el-form-item label="处理结果" prop="remark">
                  <el-input v-model="msgForm.remark" :readonly="true" type="textarea" :rows="4" placeholder=""></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-tag type="warning" style="margin-top: 20px;margin-bottom: 15px;">处理进度</el-tag>
            <el-row type="flex" justify="space-between" align="middle">
              <el-col :span="24">
                <el-steps :active="msgForm.status+1" finish-status="success">
                  <el-step title="报警">
                    <template slot="description">
                      <p>{{msgForm.createTime | filterTime}}</p>
                    </template>
                  </el-step>
                  <el-step title="接警">
                    <template slot="description">
                      <p>{{msgForm.handleTime | filterTime}}</p>
                    </template>
                  </el-step>
                  <el-step title="归档">
                    <template slot="description">
                      <p>{{msgForm.endTime | filterTime}}</p>
                    </template>
                  </el-step>
                </el-steps>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="msgDialogVisible = false">关 闭</el-button>
        </div>
      </el-dialog>

       <!-- 今日管理详情 -->
      <el-dialog title="管理详情" width="800px" :visible.sync="todayDialogVisible" :append-to-body="true" :close-on-click-modal="false">
        <div>
          <el-tabs v-model="tabActiveName" type="card" @tab-click="handleClick">
            <el-tab-pane label="上传记录" name="first">
              <el-collapse v-model="activeNames" @change="handleChange">
                <el-collapse-item name="1">
                  <template slot="title">
                    饮食记录 <i class="header-icon el-icon-info" v-if="list1.length > 0"></i>
                  </template>
                  <div v-for="item in list1" :key="item" style="color: chocolate;">
                    <span>【{{ item.createTime | filterTime(2)}}】：</span>
                    <span v-if="item.note.indexOf('http') == -1">{{ item.note }}</span>
                    <el-image :src="item.note" style="width: 150px;height: 100px;" :preview-src-list="[item.note]" v-else></el-image>
                  </div>
                </el-collapse-item>
                <el-collapse-item name="2">
                  <template slot="title">
                    运动记录 <i class="header-icon el-icon-info" v-if="list2.length > 0"></i>
                  </template>
                  <div v-for="item in list2" :key="item" style="color: chocolate;">
                    <span>【{{ item.createTime | filterTime(2)}}】：</span>
                    <span v-if="item.note.indexOf('http') == -1">{{ item.note }}</span>
                    <el-image :src="item.note" style="width: 150px;height: 100px;" :preview-src-list="[item.note]" v-else></el-image>
                  </div>
                </el-collapse-item>
                <el-collapse-item name="3">
                  <template slot="title">
                    二便记录 <i class="header-icon el-icon-info" v-if="list3.length > 0"></i>
                  </template>
                  <div v-for="item in list3" :key="item" style="color: chocolate;">
                    <span>【{{ item.createTime | filterTime(2)}}】：</span>
                    <span v-if="item.note.indexOf('http') == -1">{{ item.note }}</span>
                    <el-image :src="item.note" style="width: 150px;height: 100px;" :preview-src-list="[item.note]" v-else></el-image>
                  </div>
                </el-collapse-item>
                <el-collapse-item name="4">
                  <template slot="title">
                    睡眠记录 <i class="header-icon el-icon-info" v-if="list4.length > 0"></i>
                  </template>
                  <div v-for="item in list4" :key="item" style="color: chocolate;">
                    <span>【{{ item.createTime | filterTime(2)}}】：</span>
                    <span v-if="item.note.indexOf('http') == -1">{{ item.note }}</span>
                    <el-image :src="item.note" style="width: 150px;height: 100px;" :preview-src-list="[item.note]" v-else></el-image>
                  </div>
                </el-collapse-item>
                <el-collapse-item name="5">
                  <template slot="title">
                    用药记录 <i class="header-icon el-icon-info" v-if="list5.length > 0"></i>
                  </template>
                  <div v-for="item in list5" :key="item" style="color: chocolate;">
                    <span>【{{ item.createTime | filterTime(2)}}】：</span>
                    <span v-if="item.note.indexOf('http') == -1">{{ item.note }}</span>
                    <el-image :src="item.note" style="width: 150px;height: 100px;" :preview-src-list="[item.note]" v-else></el-image>
                  </div>
                </el-collapse-item>
                <el-collapse-item name="6">
                  <template slot="title">
                    身况记录 <i class="header-icon el-icon-info" v-if="list6.length > 0"></i>
                  </template>
                  <div v-for="item in list6" :key="item" style="color: chocolate;">
                    <span>【{{ item.createTime | filterTime(2)}}】：</span>
                    <span v-if="item.note.indexOf('http') == -1">{{ item.note }}</span>
                    <el-image :src="item.note" style="width: 150px;height: 100px;" :preview-src-list="[item.note]" v-else></el-image>
                  </div>
                </el-collapse-item>
                <el-collapse-item name="7">
                  <template slot="title">
                    舌象记录 <i class="header-icon el-icon-info" v-if="list7.length > 0"></i>
                  </template>
                  <div v-for="item in list7" :key="item" style="color: chocolate;">
                    <span>【{{ item.createTime | filterTime(2)}}】：</span>
                    <span v-if="item.note.indexOf('http') == -1">{{ item.note }}</span>
                    <el-image :src="item.note" style="width: 150px;height: 100px;" :preview-src-list="[item.note]" v-else></el-image>
                  </div>
                </el-collapse-item>
                <el-collapse-item name="8">
                  <template slot="title">
                    面相记录 <i class="header-icon el-icon-info" v-if="list8.length > 0"></i>
                  </template>
                  <div v-for="item in list8" :key="item" style="color: chocolate;">
                    <span>【{{ item.createTime | filterTime(2)}}】：</span>
                    <span v-if="item.note.indexOf('http') == -1">{{ item.note }}</span>
                    <el-image :src="item.note" style="width: 150px;height: 100px;" :preview-src-list="[item.note]" v-else></el-image>
                  </div>
                </el-collapse-item>
                <el-collapse-item name="9">
                  <template slot="title">
                    身高记录 <i class="header-icon el-icon-info" v-if="list9.length > 0"></i>
                  </template>
                  <div v-for="item in list9" :key="item" style="color: chocolate;">
                    <span>【{{ item.createTime | filterTime(2)}}】：</span>
                    <span v-if="item.note.indexOf('http') == -1">{{ item.note }}</span>
                    <el-image :src="item.note" style="width: 150px;height: 100px;" :preview-src-list="[item.note]" v-else></el-image>
                  </div>
                </el-collapse-item>
                <el-collapse-item name="10">
                  <template slot="title">
                    体重记录 <i class="header-icon el-icon-info" v-if="list10.length > 0"></i>
                  </template>
                  <div v-for="item in list10" :key="item" style="color: chocolate;">
                    <span>【{{ item.createTime | filterTime(2)}}】：</span>
                    <span v-if="item.note.indexOf('http') == -1">{{ item.note }}</span>
                    <el-image :src="item.note" style="width: 150px;height: 100px;" :preview-src-list="[item.note]" v-else></el-image>
                  </div>
                </el-collapse-item>
              </el-collapse>
              <el-form ref="todayForm" :model="todayForm" :rules="rules" label-width="80px" style="margin-top: 30px;">
                <el-row type="flex" justify="space-between" align="middle">
                  <el-col :span="24">
                    <el-form-item label="专家指导" prop="note">
                      <el-input v-model="todayForm.note" type="textarea" :rows="5" placeholder="" style="width: 100%;"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </el-tab-pane>
            <el-tab-pane label="体检记录" name="second">
              <div style="width: 100%;">
                <el-input v-model="logItemContent" :readonly="true" type="textarea" :rows="20" placeholder="" style="width: 100%;"></el-input>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="todayDialogVisible = false">关 闭</el-button>
          <el-button type="primary" @click="todayUpdateClick">确 定</el-button>
        </div>
      </el-dialog>

      <!-- 疗愈生活 -->
    <el-dialog title="记录信息" width="800px" :visible.sync="healingDialogVisible" :append-to-body="true" custom-class="outer-dialog">
      <el-form ref="healingForm" :model="healingForm" label-width="100px">
        <el-card class="box-card">
          <el-row>
            <el-col :span="12">
              <el-form-item label="记录名称" prop="reportName">
                <span>{{ healingForm.reportName }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="记录编号" prop="reportNum">
                <span>{{ healingForm.reportNum }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="指导医生" prop="tester">
                <span>{{ healingForm.tester }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="指导建议" prop="note">
                <el-input v-model="healingForm.note" placeholder="请输入内容" type="textarea" :rows="3" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-card>
        <el-card class="box-card" style="margin-top: 10px;">
          <div slot="header" class="clearfix">
            <el-tag type="danger" effect="plain">记录附件</el-tag>
            <el-table :data="healingImgList" border style="width: 100%; margin-top: 20px;"
              :header-cell-style="{ background: '#f5f7fa !important' ,color:'#909399 !important'}">
              <el-table-column prop="imgName" label="文件名称" min-width="2"></el-table-column>
              <el-table-column prop="imgUrl" label="点击预览" min-width="1">
                <template slot-scope="scope">
                  <div v-if="scope.row.imgUrl.endsWith('.pdf')">
                    <a :href="scope.row.imgUrl" target="_blank" style="font-weight: 800; color: #33ab9e">点击预览</a>
                  </div>
                  <div class="demo-image__preview" v-else>
                    <el-image style="width: 100px; height: 100px" :src="scope.row.imgUrl" :preview-src-list="srcHealingList"></el-image>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-card>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="healingDialogVisible = false">关 闭</el-button>
      </div>
    </el-dialog>

      <!-- 随访管理详情 -->
      <el-dialog title="随访管理" width="800px" :visible.sync="accessDialogVisible" :append-to-body="true">
        <div>
          <el-form ref="accessForm" :model="accessForm" :rules="rules" label-width="80px">
            <el-tabs v-model="accessActiveName" type="card" @tab-click="handleClick">
              <el-tab-pane label="随访计划" name="first">
                <el-row type="flex" justify="space-between" align="middle">
                  <el-col :span="12">
                    <el-form-item label="随访对象" prop="planInterviewee">
                      <el-input v-model="accessForm.planInterviewee" :readonly="true" ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="随访时间" prop="planTime">
                      <el-date-picker v-model="accessForm.planTime" type="date" placeholder="选择日期" disabled></el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row type="flex" justify="space-between" align="middle">
                  <el-col :span="24">
                    <el-form-item label="随访人员" prop="planVisitor">
                      <el-input v-model="accessForm.planVisitor" :readonly="true" ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row type="flex" justify="space-between" align="middle">
                  <el-col :span="24">
                    <el-form-item label="随访事项" prop="planNote">
                      <vue-ueditor-wrap class="ueditor" v-model="accessForm.planNote" :config="myConfig" disabled></vue-ueditor-wrap>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-tab-pane>
              <el-tab-pane label="随访记录" name="second">
                <el-row type="flex" justify="space-between" align="middle">
                  <el-col :span="12">
                    <el-form-item label="随访对象" prop="interviewee">
                      <el-input v-model="accessForm.interviewee" :readonly="true" ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="随访时间" prop="visitTime">
                      <el-date-picker v-model="accessForm.visitTime" type="date" placeholder="选择日期" disabled></el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row><el-row type="flex" justify="space-between" align="middle">
                  <el-col :span="24">
                    <el-form-item label="随访内容" prop="visitor">
                      <el-input v-model="accessForm.visitor" type="textarea" :readonly="true" ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row type="flex" justify="space-between" align="middle">
                  <el-col :span="24">
                    <el-form-item label="随访事项特殊备注" prop="note">
                      <vue-ueditor-wrap class="ueditor" v-model="accessForm.note" :config="myConfig" disabled></vue-ueditor-wrap>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-tab-pane>
            </el-tabs>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="accessDialogVisible = false">关 闭</el-button>
        </div>
      </el-dialog>

  </div>
</template>

<script>
import VueUeditorWrap from 'vue-ueditor-wrap' // ES6 Module
import { apiAddAlertPerson, apiUpdateAlertPerson, apiGetAlertPersonPage, apiDeleteAlertPerson,
  apiGetAlertPersonDevice, apiUpdateAlertPersonDevice, apiDeleteAlertPersonDevice,
  apiGetAlertMessagePage, apiGetJkytLog
 } from '@/api/alertManage'
import { apiGetAppletList, apiGetReportSimplePage, apiGetReportSimpleDtl, apiGetSchemePage, apiGetSchemeDtl,
  apiGetTodayRecordPage, apiGetTodayRecord, apiGetTodayLog, apiUpdateTodayRecord, apiGetAccessRecordPage, apiGetAccessRecord,
  apiGetHealingPage, apiGetHealingDtl,
 } from '@/api/clientManage'
import { apiGetIndentList } from '@/api/orderManage'
export default {
  name: '',
  props: [''],
  data() {
    return {
      PersonList: '', // 报告列表page
      UsersList: [], //
      pages: {
        page: 1, // 页数
        size: 50
      },
      SearchForm: {
        name: '',
        tel: '',
        idcard: '',
        serviceItem: '',
      },
      sexOptions: [
        {label: '男', value: 0},
        {label: '女', value: 1},
      ],
      typeOptions: [
        {label: '心率', value: 0},
        {label: '血压', value: 1},
        {label: '紧急救援', value: 2},
        {label: '睡眠雷达', value: 3},
        {label: '健康一体', value: 4},
      ],
      statusOptions: [
        {label: '启用', value: 0},
        {label: '停用', value: 1},
      ],
      siOptions: [
        {label: '客户医院治疗', value: '客户医院治疗'},
        {label: '客户疗养院康养', value: '客户疗养院康养'},
        {label: '客户居家监测', value: '客户居家监测'},
        // {label: '心梗管理', value: '心梗管理'},
        // {label: '脑梗管理', value: '脑梗管理'},
        // {label: '血压管理', value: '血压管理'},
        // {label: '血糖管理', value: '血糖管理'},
        // {label: '血脂管理', value: '血脂管理'},
        // {label: '尿酸管理', value: '尿酸管理'},
        {label: '其它', value: '其它'},
      ],
      communityOptions: [{label:'南京', value:'南京'},{label:'苏州', value:'苏州'},{label:'无锡', value:'无锡'},
        {label:'徐州', value:'徐州'},{label:'常州', value:'常州'},{label:'南通', value:'南通'},{label:'盐城', value:'盐城'},
        {label:'扬州', value:'扬州'},{label:'镇江', value:'镇江'},{label:'泰州', value:'泰州'},{label:'淮安', value:'淮安'},
        {label:'宿迁', value:'宿迁'},{label:'连云港', value:'连云港'}],
      stateOptions: [{label:'无服务', value:'无服务'},{label:'治疗中', value:'治疗中'},{label:'已死亡', value:'已死亡'}],
      deviceCodeSelect: [],
      // 富文本
      myConfig: {
        UEDITOR_HOME_URL: '/UEditor/',
        serverUrl: '',
        // 工具栏是否可以浮动
        autoFloatEnabled: false
      },
      // 验证
      rules: {
        name: [
          { required: true, message: '请输入受监护人姓名', trigger: 'blur' }
        ],
        tel: [
          { required: true, message: '请输入受监护人电话', trigger: 'blur' }
        ],
        sex: [
          { required: true, message: '请选择受监护人性别', trigger: 'blur' }
        ],
        serviceItemArr: [
          { required: true, message: '请选择受监护人服务项目', trigger: 'blur' }
        ],
        community: [
          { required: true, message: '请选择所属地区', trigger: 'blur' }
        ],
        // birth: [
        //   { required: true, message: '请选择受监护人出生日期', trigger: 'blur' }
        // ],
        // idcard: [
        //   { required: true, message: '请选择受监护人身份证号码', trigger: 'blur' }
        // ],
        // address: [
        //   { required: true, message: '请输入受监护人居住地址', trigger: 'blur' }
        // ]
      },
      deviceRules: {
        type: [
          { required: true, message: '请选择设备类型', trigger: 'blur' }
        ],
        deviceCode: [
          { required: true, message: '请输入设备码', trigger: 'blur' }
        ],
        deviceName: [
          { required: true, message: '请输入设备名', trigger: 'blur' }
        ],
      },
      // 人员
      activeName: 'first',
      lastBirth: null,
      personForm: {},
      personDialogVisible: false,
      // 设备
      drawerWidth: '1000px',
      drawer: false,
      personSelectId: null,
      personDeviceForm: {},
      personDeviceList: [],
      personDeviceDialogVisible: false,
      deviceOptions: [],
      // 报告
      ReportList: '',
      reportPages: {
        page: 1, // 页数
        size: 10
      },
      reportForm: {},
      reportImgList: [],
      srcList: [],
      reportDialogVisible: false,
      // 健管方案
      SchemeList: '',
      schemePages: {
        page: 1, // 页数
        size: 10
      },
      schemeForm: {},
      schemeImgList: [],
      srcSchemeList: [],
      schemeDialogVisible: false,
      // 报警
      MsgList: '',
      msgPages: {
        page: 1, // 页数
        size: 10
      },
      msgForm: {},
      msgDialogVisible: false,
      // 订单
      OrderList: '',
      orderPages: {
        page: 1, // 页数
        size: 10
      },
      orderForm: {},
      orderDialogVisible: false,
      // 今日管理
      TodayList: '',
      todayPages: {
        page: 1, // 页数
        size: 10
      },
      todayForm: {},
      todayDialogVisible: false,
      tabActiveName: 'first',
      activeNames: ['1'],
      list1: [],
      list2: [],
      list3: [],
      list4: [],
      list5: [],
      list6: [],
      list7: [],
      list8: [],
      list9: [],
      list10: [],
      logItemContent: '',
      // 疗愈生活
      HealingList: '',
      healingPages: {
        page: 1, // 页数
        size: 10
      },
      healingForm: {},
      healingImgList: [],
      srcHealingList: [],
      healingDialogVisible: false,
      // 随访管理
      AccessList: '',
      accessPages: {
        page: 1, // 页数
        size: 10
      },
      accessForm: {},
      accessDialogVisible: false,
      accessActiveName: 'first',

    }
  },

  components: { VueUeditorWrap },

  computed: {},

  beforeMount() {},

  mounted() {
    this.GetPersonList();
    this.GetAppletList();
  },

  methods: {
    /////////////////////////个人信息///////////////////////////
    // 搜索
    SearchBut() {
      this.GetPersonList();
    },
    handleClick(tab, event) {
      if(this.activeName == 'first') {
      } else if(this.activeName == 'second'){
        this.GetReportList();
      } else if(this.activeName == 'third'){
        this.GetSchemeList();
      } else if(this.activeName == 'fourth'){
        this.GetAlertMsgList();
      } else if(this.activeName == 'fifth'){
        // this.GetOrderList();
        this.GetTodayList();
      } else if(this.activeName == 'sixth'){
        this.GetHealingList();
      } else if(this.activeName == 'seventh'){
        this.GetAccessList();
      }
    },
    // 分页
    handleCurrentChange(val) {
      this.pages.page = val
      console.log(`当前页: ${val}`)
      this.GetPersonList()
    },
    // 接口
    // 获取基本用户的列表
    GetPersonList() {
      apiGetAlertPersonPage({
        name: this.SearchForm.name,
        tel: this.SearchForm.tel,
        idcard: this.SearchForm.idcard,
        serviceItem: this.SearchForm.serviceItem,
        page: this.pages.page,
        pageSize: this.pages.size
      }).then(res => {
        if (res.status === 0) {
          this.PersonList = res.data
          this.PersonList.list.forEach(r => {
            r.isToday = this.isToday(r.createTime);
          });
        }
      })
    },
    GetPersonDeviceList() {
      apiGetAlertPersonDevice({
        personId: this.personSelectId
      }).then(res =>{
        if(res.status == 0) {
          this.personDeviceList = res.data;
        }
      });
    },
    GetAppletList() {
      apiGetAppletList({
      }).then(res => {
        if (res.status === 0) {
          this.UsersList = res.data
        }
      })
    },
    bindPersonChange(key) {
      this.UsersList.forEach(u => {
        if(u.id == key) {
          this.personForm.tel = u.tel;
          return;
        }
      });
    },
    deviceTypeChange(key) {
      apiGetAlertPersonDevice({
        type: key,
        search: 'unbind',
      }).then(res => {
        if(res.status == 0) {
          this.deviceOptions = res.data;
          this.$nextTick(()=>{
            this.$set(this.personDeviceForm, 'deviceCodeSelect', null);
            this.$set(this.personDeviceForm, 'deviceCode', '');
            this.$set(this.personDeviceForm, 'deviceName', '');
            this.$set(this.personDeviceForm, 'normalRange', '');
            this.$set(this.personDeviceForm, 'status', 0);
          })
        }
      });
    },
    bindDeviceChange(key) {
      this.deviceOptions.forEach(d => {
        if(d.deviceCode == key) {
          this.$nextTick(()=>{
            this.$set(this.personDeviceForm, 'deviceCode', d.deviceCode);
            this.$set(this.personDeviceForm, 'deviceName', d.deviceName);
            this.$set(this.personDeviceForm, 'normalRange', '');
            this.$set(this.personDeviceForm, 'status', 0);
          })
        }
      });
    },
    // 人员信息
    personAddBut() {
      this.personForm = {};
      this.personDialogVisible = true;
    },
    personUpdateBut(row) {
      this.personForm = row;
      if(this.personForm.serviceItem) {
        this.personForm.serviceItemArr = this.personForm.serviceItem.split(',');
      }
      if(this.personForm.birth) {
        this.personForm.birth = new Date(this.personForm.birth);
      }
      this.activeName = 'first';
      this.personDialogVisible = true;
    },
    personDeviceBut(row) {
      this.drawer = true;
      this.personSelectId = row.id;
      this.GetPersonDeviceList();
    },
    personLogBut(row) {
      const data = {
        id: row.id
      }
      this.$router.push({
        path: '/logInfo',
        query: {
          info: this.$Base64.encode(JSON.stringify(data))
        }
      })
    },
    personUpdateClick() {
      this.$refs['personForm'].validate(valid => {
        if (valid) {
          if(this.personForm.uid) {
            let myTel = "";
            this.UsersList.forEach(u=>{
              if(u.id == this.personForm.uid) {
                myTel = u.tel;
              }
            });
            if(myTel != this.personForm.tel) {
              this.$message.error("请检查绑定账号和联系电话是否一致");
              return;
            } 
          }
          this.personForm.serviceItem = this.personForm.serviceItemArr.join(',');
          let birthLong = 0;
          this.lastBirth = null;
          if(this.personForm.birth) {
            birthLong = this.personForm.birth.getTime();
            console.log('birthLong', birthLong);
            this.lastBirth = this.personForm.birth;
            this.personForm.birth = null;
            delete this.personForm.birth;
            this.personForm.birthLong = birthLong;
          }
          if(this.personForm.id == null) {// 新增
            apiAddAlertPerson(
              this.personForm
            ).then(res => {
              if (res.status === 0) {
                this.personDialogVisible = false;
                this.GetPersonList();
              } else {
                if(this.lastBirth) {
                  this.personForm.birth = this.lastBirth;
                }
                this.$message.error(res.msg);
              }
            });
          } else {// 修改
            this.personForm.createTime = null;
            let filteredObj = this.removeNullPropertiesDeep(this.personForm);
            apiUpdateAlertPerson(
              filteredObj
            ).then(res => {
              if (res.status === 0) {
                this.personDialogVisible = false;
                this.GetPersonList();
              } else {
                if(this.lastBirth) {
                  this.personForm.birth = this.lastBirth;
                }
                this.$message.error(res.msg);
              }
            });
          }
        }
      });
    },
    personDeleteClick(row){
      this.$confirm('确认删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
          let personId = row.id;
          console.log("personId", personId);   
          apiDeleteAlertPerson({id: personId}).then(res => {
            if (res.status === 0) {
              this.$message({message: '删除成功', type: 'success'});
              this.GetPersonList();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作'
          })
        })
    },
    // 监护设备
    personDeviceAddBut() {
      this.personDeviceForm = {type: 0,status: 0};
      this.personDeviceDialogVisible = true;
    },
    personDeviceUpdateBut(index, row) {
      this.$nextTick(()=>{
        this.$set(this.personDeviceForm, 'personId', row.personId);
        this.$set(this.personDeviceForm, 'type', row.type);
        this.$set(this.personDeviceForm, 'deviceCode', row.deviceCode);
        this.$set(this.personDeviceForm, 'deviceName', row.deviceName);
        this.$set(this.personDeviceForm, 'normalRange', row.normalRange);
        this.$set(this.personDeviceForm, 'status', row.status);
      });
      this.personDeviceDialogVisible = true;
    },
    personDeviceDeleteClick(index, row) {
      this.$confirm('确认解绑该设备？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
          let personDeviceId = row.id;
          console.log("personDeviceId", personDeviceId);   
          apiDeleteAlertPersonDevice({id: personDeviceId}).then(res => {
            if (res.status === 0) {
              this.$message({message: '解绑成功', type: 'success'});
              this.GetPersonDeviceList();
            }
          });
        })
        .catch(() => {
          this.$message({type: 'info', message: '已取消操作'});
        })
    },
    personDeviceUpdateClick() {
      this.$refs['personDeviceForm'].validate(valid => {
        if (valid) {
          console.log('personDevice',this.personDeviceForm);
          this.personDeviceForm.personId = this.personSelectId;
          apiUpdateAlertPersonDevice(
            this.personDeviceForm
          ).then(res => {
            if (res.status === 0) {
              this.personDeviceDialogVisible = false;
              this.GetPersonDeviceList();
            }
          });
        }
      });
    },
    handleClose() {
      this.drawer = false;
    },
    //////////////////////////////体检报告
    handleReportCurrentChange(val) {// 分页
      this.reportPages.page = val
      console.log(`当前页: ${val}`)
      this.GetReportList()
    },
    GetReportList() {
      if(this.personForm == null || this.personForm.id == null) {
        return;
      }
      apiGetReportSimplePage({
        personId: this.personForm.id,
        page: this.reportPages.page,
        pageSize: this.reportPages.size
      }).then(res => {
        if (res.status === 0) {
          this.ReportList = res.data
        }
      })
    },
    reportClick(row) {
      this.reportForm = {};
      this.reportImgList = [];
      apiGetReportSimpleDtl({
        id: row.id
      }).then(res => {
        if(res.status == 0) {
          this.reportForm = res.data;
          if(this.reportForm.urls == null) {
          } else {
            let urlArr = this.reportForm.urls.split(",");
            let nameArr = this.reportForm.unames.split(",");
            urlArr.forEach( (url, index) => {
              this.reportImgList.push({imgName: nameArr[index], imgUrl: urlArr[index]});
            });
            this.calSrcList();
          }
          if(this.reportForm.doTime) {
            this.reportForm.doTime = new Date(this.reportForm.doTime);
          }
          this.reportDialogVisible = true;
        }
      });
    },
    calSrcList() {
      this.srcList = [];
      this.reportImgList.forEach(ri=>{
        if(!ri.imgUrl.endsWith(".pdf")) {
          this.srcList.push(ri.imgUrl);
        }
      });
    },
    //////////////////健管方案
    handleSchemeCurrentChange(val) {
      this.schemePages.page = val
      console.log(`当前页: ${val}`)
      this.GetSchemeList()
    },
    GetSchemeList() {
      if(this.personForm == null || this.personForm.id == null) {
        return;
      }
      apiGetSchemePage({
        personId: this.personForm.id,
        page: this.schemePages.page,
        pageSize: this.schemePages.size
      }).then(res => {
        if (res.status === 0) {
          this.SchemeList = res.data
        }
      })
    },
    schemeClick(row) {
      this.schemeForm = {};
      this.schemeImgList = [];
      apiGetSchemeDtl({
        id: row.id
      }).then(res => {
        if(res.status == 0) {
          this.schemeForm = res.data;
          if(this.schemeForm.urls == null) {
          } else {
            let urlArr = this.schemeForm.urls.split(",");
            let nameArr = this.schemeForm.unames.split(",");
            urlArr.forEach( (url, index) => {
              this.schemeImgList.push({imgName: nameArr[index], imgUrl: urlArr[index]});
            });
            this.calSrcSchemeList();
          }
          if(this.schemeForm.doTime) {
            this.schemeForm.doTime = new Date(this.schemeForm.doTime);
          }
          this.schemeDialogVisible = true;
        }
      });
    },
    calSrcSchemeList() {
      this.srcSchemeList = [];
      this.schemeImgList.forEach(ri=>{
        if(!ri.imgUrl.endsWith(".pdf")) {
          this.srcSchemeList.push(ri.imgUrl);
        }
      });
    },
    //////////////////报警
    handleMsgCurrentChange(val) {
      this.msgPages.page = val
      console.log(`当前页: ${val}`)
      this.GetAlertMsgList()
    },
    GetAlertMsgList() {
      if(this.personForm == null || this.personForm.id == null) {
        return;
      }
      apiGetAlertMessagePage({
        personId: this.personForm.id,
        page: this.msgPages.page,
        pageSize: this.msgPages.size
      }).then(res => {
        if (res.status === 0) {
          this.MsgList = res.data
        }
      })
    },
    msgClick(row) {
      this.msgForm = row;
      this.msgDialogVisible = true;
    },
    //////////////订单
    handleOrderCurrentChange(val) {
      this.orderPages.page = val
      console.log(`当前页: ${val}`)
      this.GetOrderList();
    },
    GetOrderList() {
      if(this.personForm == null || this.personForm.uid == null) {
        return;
      }
      apiGetIndentList({
        uid: this.personForm.uid,
        page: this.orderPages.page,
        pageSize: this.orderPages.size
      }).then(res => {
        if (res.status === 0) {
          this.OrderList = res.data
        }
      })
    },
    //////////////////今日管理
    handleTodayCurrentChange(val) {
      this.todayPages.page = val
      console.log(`当前页: ${val}`)
      this.GetTodayList()
    },
    GetTodayList() {
      if(this.personForm == null || this.personForm.id == null) {
        return;
      }
      apiGetTodayRecordPage({
        personId: this.personForm.id,
        page: this.todayPages.page,
        pageSize: this.todayPages.size
      }).then(res => {
        if (res.status === 0) {
          this.TodayList = res.data
          this.TodayList.list.forEach(t => {
            t.isToday = this.isToday(t.createTime);
          });
        }
      })
    },
    todayClick(row) {
      this.todayDialogVisible = true;
      this.list1 = [],
      this.list2 = [],
      this.list3 = [],
      this.list4 = [],
      this.list5 = [],
      this.list6 = [],
      this.list7 = [],
      this.list8 = [],
      this.list9 = [],
      this.list10 = [],
      apiGetTodayRecord({
        id: row.id
      }).then(res => {
        if (res.status === 0) {
          this.todayForm = res.data;
        }
      })
      apiGetTodayLog({
        rid: row.id
      }).then(res => {
        if (res.status === 0) {
          let logs = res.data;
          logs.forEach( log => {
            if(log.type == 1) {
              this.list1.push(log);
            } else if(log.type == 2) {
              this.list2.push(log);
            } else if(log.type == 3) {
              this.list3.push(log);
            } else if(log.type == 4) {
              this.list4.push(log);
            } else if(log.type == 5) {
              this.list5.push(log);
            } else if(log.type == 6) {
              this.list6.push(log);
            } else if(log.type == 7) {
              this.list7.push(log);
            } else if(log.type == 8) {
              this.list8.push(log);
            } else if(log.type == 9) {
              this.list9.push(log);
            } else if(log.type == 10) {
              this.list10.push(log);
            }
          });
        }
      })
      this.logItemContent = "";
      apiGetJkytLog({uid: row.uid, createTimeLong: row.createTime}).then(res => {
        if(res.status == 0) {
          this.logItemContent = res.data.content;
        }
      });
    },
    todayUpdateClick() {
      this.$refs['todayForm'].validate(valid => {
        if (valid) {
          apiUpdateTodayRecord({
            id: this.todayForm.id,
            note: this.todayForm.note,
          }).then(res => {
            if (res.status === 0) {
              this.$message({message: '保存成功', type: 'success'});
              this.todayDialogVisible = false;
              this.todayForm = {};
              this.GetTodayList();
            } else {
              this.$message({message: '保存失败', type: 'error'});
            }
          });
        }
      });
    },
    // 是否当天
    isToday(date) {
        var d0 = new Date();
        var y0 = d0.getFullYear(); 
        var m0 = d0.getMonth() + 1; 
        var d0 = d0.getDate(); 
        var d1 = new Date(date);
        var y1 = d1.getFullYear(); 
        var m1 = d1.getMonth() + 1; 
        var d1 = d1.getDate(); 
        return y0==y1 && m0==m1 && d0==d1;
    },
    handleChange() {

    },
    //////////////////////////////疗愈生活
    handleHealingCurrentChange(val) {// 分页
      this.healingPages.page = val
      console.log(`当前页: ${val}`)
      this.GetHealingList()
    },
    GetHealingList() {
      if(this.personForm == null || this.personForm.id == null) {
        return;
      }
      apiGetHealingPage({
        personId: this.personForm.id,
        page: this.healingPages.page,
        pageSize: this.healingPages.size
      }).then(res => {
        if (res.status === 0) {
          this.HealingList = res.data
        }
      })
    },
    healingClick(row) {
      this.healingForm = {};
      this.healingImgList = [];
      apiGetHealingDtl({
        id: row.id
      }).then(res => {
        if(res.status == 0) {
          this.healingForm = res.data;
          if(this.healingForm.urls == null) {
          } else {
            let urlArr = this.healingForm.urls.split(",");
            let nameArr = this.healingForm.unames.split(",");
            urlArr.forEach( (url, index) => {
              this.healingImgList.push({imgName: nameArr[index], imgUrl: urlArr[index]});
            });
            this.calSrcHealingList();
          }
          this.healingDialogVisible = true;
        }
      });
    },
    calSrcHealingList() {
      this.srcHealingList = [];
      this.healingImgList.forEach(ri=>{
        if(!ri.imgUrl.endsWith(".pdf")) {
          this.srcHealingList.push(ri.imgUrl);
        }
      });
    },
    //////////////////随访管理
    handleAccessCurrentChange(val) {
      this.accessPages.page = val
      console.log(`当前页: ${val}`)
      this.GetAccessList()
    },
    GetAccessList() {
      if(this.personForm == null || this.personForm.id == null) {
        return;
      }
      apiGetAccessRecordPage({
        personId: this.personForm.id,
        page: this.accessPages.page,
        pageSize: this.accessPages.size
      }).then(res => {
        if (res.status === 0) {
          this.AccessList = res.data
        }
      })
    },
    accessClick(row) {
      this.accessForm = {};
      this.todayImgList = [];
      apiGetAccessRecord({
        id: row.id
      }).then(res => {
        if(res.status == 0) {
          this.accessForm = res.data;
          this.accessDialogVisible = true;
        }
      });
    },

    removeNullPropertiesDeep(obj) {
      Object.keys(obj).forEach(key => {
        if (obj[key] === null) {
          delete obj[key];
        } else if (typeof obj[key] === 'object' && obj[key] !== null) {
          this.removeNullPropertiesDeep(obj[key]); // 递归调用
        }
      });
      return obj;
    }


  },

  watch: {}
}
</script>
<style lang="scss" scoped>
.flex {
  display: flex;
}
.FZ0875 {
  font-size: 0.875em;
}
.textalignLeft {
  text-align: left;
}
.vue {
  padding: 0 10px;
  background-color: #fff;
  border-left: 2px solid #119685;
  .header {
    height: 92px;
    .headSearch {
      .headSearch-left {
        width: 85%;
        float: left;
        .form-data {
          // span {
          //   width: 90px;
          // }
          /deep/ .el-date-editor,
          .el-input,
          .el-cascader {
            width: 200px;
          }
        }
      }
      .headSearch-right {
        width: 10%;
        float: right;
      }
    }
    .text {
      text-align: left;
      // font-size: 0.875em;
      color: #119685;
      padding: 10px 5px;
    }
  }
  .content {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: calc(100vh - 214px);
    /deep/ .el-table {
      overflow: auto;
      height: calc(100vh - 272px);
    }
    /deep/ .el-table .warning-row {
      background: oldlace;
    }

    /deep/ .el-table .success-row {
      background: #f0f9eb;
    }
    .Pagination {
      justify-content: space-between;
      padding: 10px 20px;
      align-items: center;
      font-size: 0.875em;
      color: #7b7b7b;
      .text {
        .pageNum {
          color: #119685;
        }
      }
    }
  }
}
.dialog {
}
</style>
